import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MISSOES_PROPORCIONAIS, entradaDoCatalogo } from './jornada.catalogo';
import { FASES } from './jornada.copy';
import { EntradaDoCatalogo, JornadaResposta, MissaoResposta } from './jornada.model';

/** As missões CONTÍNUAS que medem a saúde atual — as proporcionais do catálogo. */
const SINAIS = MISSOES_PROPORCIONAIS;

interface Sinal {
  entrada: EntradaDoCatalogo;
  missao: MissaoResposta;
}

/**
 * A coluna da direita: a confiança dos números (barras das contínuas), a
 * coleção de conquistas (uma medalha por fase) e o que vem depois.
 */
@Component({
  selector: 'mg-painel-lateral',
  templateUrl: './painel-lateral.component.html',
  styleUrls: ['./painel-lateral.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PainelLateralComponent {
  @Input({ required: true }) dados!: JornadaResposta;

  @Input() idsNovos: string[] = [];
  @Output() readonly selecionar = new EventEmitter<number>();
  protected readonly FASES = FASES;

  protected novas(numero: number): boolean {
    return this.dados.fases.find(f => f.numero === numero)?.missoes.some(m =>
      this.idsNovos.includes(m.id) && m.estado === 'concluida' && m.disponivel,
    ) ?? false;
  }

  protected resumo(numero: number): string {
    const missoes = this.dados.fases.find(f => f.numero === numero)?.missoes
      .filter(m => m.disponivel && m.estado !== 'nao_se_aplica') ?? [];
    const feitas = missoes.filter(m => m.estado === 'concluida').length;
    return `${feitas} de ${missoes.length} missões`;
  }

  protected get sinais(): Sinal[] {
    const todas = this.dados.fases.flatMap(fase => fase.missoes);

    return SINAIS.flatMap(id => {
      const missao = todas.find(m => m.id === id);

      return missao ? [{ entrada: entradaDoCatalogo(id), missao }] : [];
    });
  }

  protected obtida(numero: number): boolean {
    return this.dados.fases.find(fase => fase.numero === numero)?.concluida ?? false;
  }

  protected get proximaFase(): (typeof FASES)[number] | null {
    return FASES.find(fase => fase.numero === this.dados.fase_atual + 1) ?? null;
  }
}
